<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1Cr61sR/tc-custom/9781449487850.jpg?1720280500427" alt="This image is the cover for the book Stuff I've Been Feeling Lately"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stuff I've Been Feeling Lately
      </h1>
      <p class="bookDescription body article font2">
        <p>Structured like an old-school mix-tape, <i>Stuff I've Been Feeling Lately</i> is Alicia Cook's lyric message to anyone who has dealt with addiction. "Side A" touches on all aspects of the human condition: life, death, love, trauma, and growth. "Side B" contains haunting black-out remixes of those poems.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alicia Cook
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?606bb38c